import { type EidCategories } from '@app/client';

//eg. MULTIPLE addressString = W3siNDEwMCI6IjB4OTdmNzMwN0U2NzY0OEZlYTAyM2NDMzZmZjQyQURkMDYzM0MyNjc5ZHxDb29sIEV0aCBGcmlkZ2UifSx7IjQxMjEiOiIweDc5RjQyMTU4RUFiM2Q5NTNGRjE4ODgyYzIwYzY4NjU5ODQzNTQ2NTF8VGVzIFdhbGxldCBOYW1lIn1d
//(though we should only be getting one address at a time now)
// eg. [{ 0x0101: '9C728A0848BAA67F7927A432F80718C9A0603246EC13E3D48D675BA56600B677|Unwelcome Fridge|description' }] => W3siNDEwMCI6IjB4OTdmNzMwN0U2NzY0OEZlYTAyM2NDMzZmZjQyQURkMDYzM0MyNjc5ZHxVbndlbGNvbWUgRnJpZGdlfGRlc2NyaXB0aW9uIn1d
// eg. [{ 0x0101: '425590BD987737669B3692F87EBF6AC7EB27F819018667EC7F5CDB2ED156CC16' }] => W3siMjU3IjoiNDI1NTkwQkQ5ODc3Mzc2NjlCMzY5MkY4N0VCRjZBQzdFQjI3RjgxOTAxODY2N0VDN0Y1Q0RCMkVEMTU2Q0MxNiJ9XQ==
// eg. [{ 0x0101: '9C728A0848BAA67F7927A432F80718C9A0603246EC13E3D48D675BA56600B677' }] => W3siMjU3IjoiOUM3MjhBMDg0OEJBQTY3Rjc5MjdBNDMyRjgwNzE4QzlBMDYwMzI0NkVDMTNFM0Q0OEQ2NzVCQTU2NjAwQjY3NyJ9XQ==

export const addressJSONToInsertTags = (addressString: string) => {
    const insertTags: EidCategories[] = [];

    const decoded = atob(addressString);
    const parsedArray = JSON.parse(decoded);
    if (parsedArray?.length) {
        parsedArray.forEach((a) => {
            const tag = {
                tag: '0x' + (+Object.keys(a)[0]).toString(16).padStart(4, '0'),
                data: Object.values(a)[0],
            };
            insertTags.push(tag as unknown as EidCategories);
        });
    }
    return insertTags;
};
